import { c as _c } from "react/compiler-runtime";
import { postOrgOnboardingSessionMutation } from '@onefootprint/fetch-dashboard';
import { useMutation } from '@tanstack/react-query';
const useOrgCreateOnboardingSession = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...postOrgOnboardingSessionMutation()
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useOrgCreateOnboardingSession;